/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { ResumeSubSection } from '../sub-section/sub-section.model';

/**
 * Data model for the Custom resume section.
 */
export class ResumeCustomSubSection extends ResumeSubSection {
  /**
   * User's description of themselves.
   */
  public customDescription : string = ' ';

  /**
   * User's title of custom section.
   */
  public customTitle : string;

  /**
   * Default constructor.
   *
   * @param init Optional partial object definition.
   */
  constructor(init?:Partial<ResumeCustomSubSection>) {
    super(init);
    Object.assign(this, init);
  }
}
